(function (angular) {
  "use strict";

  angular.module("app").service("MemberPackagesApi", memberPackagesResource);

  memberPackagesResource.$inject = ["settings", "$resource"];

  function memberPackagesResource(settings, $resource) {
    /**
     * Adds extra methods and values. Expects "this" to be bound to an page object
     * @return {this}
     */
    function transform() {
      return this;
    }

    // Create the resource
    var resource = $resource(
      settings.apiBase + "/member-packages/:id",
      {},
      {
        get: {
          method: "GET",
          params: {
            type: "page",
          },
          responseType: "json",
          transformResponse: function (response) {
            if (typeof response === "string") {
              response = JSON.parse(response);
            }

            if (Array.isArray(response.data)) {
              angular.forEach(response.data, function (page) {
                transform.call(page);
              });
            } else {
              if (response.data) {
                transform.call(response.data);
              }
            }

            return response;
          },
        },
        update: {
          method: "PUT",
          responseType: "json",
          params: {
            id: "@id",
          },
          transformResponse: function (response) {
            if (typeof response === "string") {
              response = JSON.parse(response);
            }

            if (response.data) {
              transform.call(response.data);
            }
            return response;
          },
        },
        delete: {
          method: "DELETE",
        },
      },
    );
    resource.prototype.transform = transform;

    return resource;
  }
})(angular);
